import { GET_ALL_COLUMNS_SUCCESS } from "../channel/type";
import { channelType } from "./transformer";

const INITIAL_STATE = {
    accountData: {},
    tables: null,
    dimensions: [],
    metrics: [],
    metricsUpdated: false,
    currency: null
};


const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${channelType}.GET_ACCOUNT_SUMMARY_SUCCESS`:
            const username = action.payload.username;
            const email = action.payload.email;
            const accountList = action.payload.accountIds.map(data => ({
                title: data.advertiser_name,
                subtitle: data.advertiser_id,
                accountId: data.advertiser_id,
            }));
            return { ...state, accountData: { users: [{ username: username, email: email }], accountList: accountList } };
        case `${channelType}.DISCONNECT_ACCOUNT_SUCCESS`:
        case `${channelType}.GET_ACCOUNT_SUMMARY_FAILURE`:
            return { ...INITIAL_STATE };
        case `${channelType}.GET_COLUMNS_SUCCESS`:
            const dimensions = action.payload.columns.filter(c => c.type === "DIMENSION");
            const metrics = action.payload.columns.filter(c => c.type === "METRIC");
            return { ...state, dimensions: dimensions, metrics: metrics, metricsUpdated: true };
        case GET_ALL_COLUMNS_SUCCESS:
            const cc = action.payload.filter(column => column.source === channelType).map(column => ({
                id: column.id,
                name: column.name,
                dataType: column.format ?? "FLOAT",
                group: "Customized",
            }));
            return { ...state, metrics: state.metrics.filter(m => m.group !== "Customized").concat(cc) };
        case `${channelType}.GET_CURRENCY_SUCCESS`:
            return { ...state, currency: action.payload.currency };
        default:
            return state;
    }
};

export default reducer;
